<template>
  <div class="shaonv">
    <div class="Index">
      <div class="bg"></div>

      <div class="login">
        <template v-if="!getStatus">
          <p class="loginTitle">登录免费领彩金</p>

          <div class="loginInput">
            <input type="text" v-model="vipAccount" placeholder="请输入您的APPID" />
          </div>
          <div class="loginBtn" @click="loginFunc">
            <p>点击领取</p>
          </div>

          <img class="one" src="../assets/one.png" alt />
        </template>

        <template v-if="getStatus">
          <img class="gift" src="../assets/gift.png"  @click="toHuiYinNiao" alt />
          <div class="loginBtn" @click="toHuiYinNiao">
            <p>领取裸聊机会</p>
          </div>
          <div class="getText">太惊喜了！您已成功获得裸聊机会</div>
        </template>
      </div>

      <div class="content">
        <img class="recommend" src="../assets/recommend.png" alt />

        <div class="chat">
          <div class="chatArea" @click="toHuiYinNiao"></div>
          <img src="../assets/chat.gif" alt />
        </div>

        <div class="medicine">
          <div class="medicineArea" @click="toHuiYinNiao"></div>
          <img src="../assets/medicine.gif" alt />
        </div>

        <img class="hotActive" src="../assets/hot_active.png" alt />

        <div class="hot">
          <div class="hotLi" @click="toRed">
            <img src="../assets/hot1.gif" alt />
          </div>
          <div class="hotLi" @click="toTurnTable">
            <img src="../assets/hot2.gif" alt />
          </div>
        </div>
      </div>
    </div>

    <!-- 装饰 -->
    <div class="decoration1" @click="toHuiYinNiao">
      <img src="../assets/decoration1.png" alt />
    </div>

    <div class="decoration2" @click="toHuiYinNiao">
      <img src="../assets/decoration2.png" alt />
    </div>

    <div class="decoration3" @click="toHuiYinNiao">
      <img src="../assets/decoration3.png" alt />
    </div>

    <!-- 获奖弹窗 -->
    <div class="getRed" v-show="getRedStatus">
      <div class="getRedAlert">
        <img src="../assets/getMoney.png" alt />

        <div class="closeGetRedArea" @click="closeGetRed"></div>
      </div>
    </div>

    <!-- 失败弹窗 -->
    <div class="loseRed" v-show="loseRedStatus">
      <div class="loseRedAlert">
        <img src="../assets/loseMoney.png" alt />

        <div class="loseRedAlertText">
          <p>{{loseText}}</p>
        </div>

        <div class="closeloseRedArea" @click="closRedLose"></div>
      </div>
    </div>

    <!-- 遮罩层 -->
    <div class="mask" v-if="false"></div>
  </div>
</template>

<script>
import { hynget, getConfig } from "@/api/index";
import { Message, Loading } from "element-ui";

export default {
  name: "turn-table",
  props: {
    msg: String,
  },
  data() {
    return {
      loseRedStatus: false,
      loseText: "",
      huiyinniiaoUrl: "",
      redUrl: "",
      turntableUrl: "",
      loginStatus: false,
      vipAccount: "",
      loginLoading: false,
      getRedStatus: false,
      getStatus: false,
    };
  },
  methods: {
    async loginFunc() {
      if (!this.vipAccount) {
        Message({
          message: "请输入账号！",
          type: "warning",
          duration: 5 * 1000,
        });
      } else {
        this.loginLoading = Loading.service({
          fullscreen: true,
          background: "rgba(255, 255, 255, 0.3)",
        });

        const res = await hynget({
          appid: process.env.VUE_APP_APPID,
          username: this.vipAccount,
        });
        if (res.code === 200) {
          this.getRedStatus = true;
          this.getStatus = true;
        } else if (res.code === 400) {
          this.loseText = res.msg;
          this.loseRedStatus = true;
        } else {
          this.loseText = res.msg;
          this.loseRedStatus = true;
        }

        this.loginLoading.close();
      }
    },

    // 点击关闭获奖弹窗
    closeGetRed() {
      this.getRedStatus = false;
    },
    // 点击失败弹窗
    closRedLose() {
      this.loseRedStatus = false;
    },
    // 跳转转盘
    toTurnTable() {
      window.location.href = this.turntableUrl;
    },
    // 跳转红包
    toRed() {
      window.location.href = this.redUrl;
    },
    // 跳转回音鸟
    toHuiYinNiao() {
      window.location.href = this.huiyinniiaoUrl;
    },
  },
  async mounted() {
    // 配置
    getConfig({ appid: process.env.VUE_APP_APPID }).then((res) => {
      res.data.forEach((v) => {
        if (v.key == "hyn_url") {
          this.huiyinniiaoUrl = v.value;
        }

        if (v.key == "zp_url") {
          this.turntableUrl = v.value;
        }

        if (v.key == "packet_url") {
          this.redUrl = v.value;
        }
      });
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.shaonv {
  position: relative;
}

.content {
  background: url(../assets/bg_content.jpg) no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  min-height: 1477px;
  box-sizing: border-box;
  text-align: center;
}

.bg {
  background: url("../assets/bg.jpg") no-repeat;
  background-size: 100%;
  width: 540px;
  height: 790px;
  position: relative;
  .lookDetails {
    position: absolute;
    bottom: 55px;
    left: 50%;
    transform: translate(-50%, 0);
    width: 218px;
    cursor: pointer;
  }
}

.login {
  background: url("../assets/loginbg.png") no-repeat;
  background-size: 100% 100%;
  border-radius: 10px;
  position: absolute;
  top: 703px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 452px;
  height: 412px;
  text-align: center;
  .loginTitle {
    color: #fff;
    font-size: 31px;
    text-align: center;
    margin: 37px 0;
  }

  .getText {
    color: #fff;
    font-size: 24px;
    margin-top: 10px;
  }
  .loginTips {
    color: #fff;
    text-align: center;
    margin-top: -10px;
    font-size: 19px;
  }
  .loginInput {
    background: url("../assets/input.png") no-repeat;
    background-size: 100% 100%;
    width: 390px;
    height: 60px;
    margin: 0 auto 22px;
    position: relative;
    input {
      background: none;
      border: 0;
      color: #d273eb;
      font-size: 22px;
      width: 321px;
      margin: 17px 0 0 0;
      text-align: center;
      &::placeholder {
        color: #727272;
        font-size: 22px;
      }
    }
    input[type="text"]:focus {
      outline: none;
    }
  }

  .gift {
    width: 394px;
    margin: 50px 0 25px 0;
  }

  .loginBtn {
    background: url("../assets/loginBtn.png") no-repeat;
    background-size: 100% 100%;
    width: 390px;
    height: 57px;
    text-align: center;
    line-height: 47px;
    font-size: 21px;
    font-weight: bold;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      color: #fff;
      font-size: 26px;
    }
  }

  .one {
    width: 388px;
    margin-top: 32px;
  }
}

.recommend {
  margin-top: 366px;
  width: 516px;
  margin-bottom: 20px;
}

.chat {
  margin-bottom: 20px;
  position: relative;
  .chatArea {
    position: absolute;
    width: 252px;
    height: 40px;
    left: 28px;
    bottom: 24px;
  }
  img {
    width: 516px;
  }
}

.medicine {
  margin-bottom: 40px;
  position: relative;
  .medicineArea {
    position: absolute;
    width: 203px;
    height: 52px;
    left: 28px;
    bottom: 37px;
  }
  img {
    width: 516px;
  }
}

.hotActive {
  width: 520px;
  margin-bottom: 10px;
}

.hot {
  display: flex;
  justify-content: space-between;
  border: 1px solid #c63292;
  padding: 17px;
  margin: 15px;
  border-radius: 15px;
  .hotLi {
    width: 229px;
    height: 300px;
    border-radius: 15px;
    overflow: hidden;
    position: relative;
    img {
      width: 100%;
      border-radius: 15px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}

.decoration1 {
  position: absolute;
  right: 5px;
  top: 466px;
  cursor: pointer;
  color: #fff;
  z-index: 5;
  animation: decoration1 1.5s infinite alternate;

  @keyframes decoration1 {
    from {
      transform: translate(0, -30px);
    }
    to {
      transform: translate(0, 0);
    }
  }
  img {
    width: 160px;
  }
}

.decoration2 {
  position: absolute;
  left: 19px;
  top: 520px;
  cursor: pointer;
  color: #fff;
  z-index: 6;
  animation: decoration2 1.5s infinite alternate;

  @keyframes decoration2 {
    from {
      transform: translate(0, 30px);
    }
    to {
      transform: translate(0, 0);
    }
  }
  img {
    width: 184px;
  }
}

.decoration3 {
  position: absolute;
  left: 131px;
  top: 305px;
  cursor: pointer;
  color: #fff;
  z-index: 5;
  img {
    width: 305px;
  }
}

.getRed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;

  .getRedAlert {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;

    img {
      width: 400px;
    }
    .getRedArea {
      position: absolute;
      left: 217px;
      bottom: 258px;
      width: 374px;
      height: 75px;
      cursor: pointer;
      border-radius: 25px;
    }

    .closeGetRedArea {
      position: absolute;
      left: 24px;
      bottom: 46px;
      width: 352px;
      height: 60px;
      cursor: pointer;
      border-radius: 25px;
    }
    .getRedTips {
      position: absolute;
      left: 50%;
      top: 147px;
      transform: translate(-50%, 0);
      color: #202022;
      font-size: 26px;
      width: 100%;
      text-align: center;
      span {
        color: #ed2120;
        margin-left: -5px;
      }
    }
    .getRedAlertText {
      position: absolute;
      left: 50%;
      top: 204px;
      transform: translate(-50%, 0);
      height: 78px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 290px;
      font-weight: bold;
      p {
        font-size: 85px;
        color: #fd1724;

        span {
          font-size: 35px;
          margin-left: -21px;
        }
      }
    }
  }
}

.loseRed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 6;

  .loseRedAlert {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;

    img {
      width: 400px;
    }
    .loseRedArea {
      position: absolute;
      left: 217px;
      bottom: 258px;
      width: 374px;
      height: 75px;
      cursor: pointer;
      border-radius: 25px;
    }

    .closeloseRedArea {
      position: absolute;
      left: 26px;
      bottom: 52px;
      width: 349px;
      height: 65px;
      cursor: pointer;
      border-radius: 25px;
    }

    .loseRedAlertText {
      position: absolute;
      left: 50%;
      top: 230px;
      transform: translate(-50%, 0);
      height: 49px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 290px;
      p {
        color: #777777;
        font-size: 21px;
        text-align: center;
      }
    }
  }
}
</style>
